import {
  Alert,
  Autocomplete,
  Box,
  Button,
  ButtonGroup,
  ClickAwayListener,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Drawer,
  FormControl,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Modal,
  Paper,
  Popper,
  Skeleton,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ShareIcon from "@mui/icons-material/Share";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CandidateInfo from "./candidateInfo";
import CandidateActivities from "./candidateActivities";
import axios from "axios";
import { useSelector } from "react-redux";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import Avatar from "@mui/material/Avatar";
import { useParams } from "react-router-dom";
import Questionnairedata from "./Questionnairedata";
import Questionpop from "./Questionpop";
import CandidateEditableProfile from "./CandidateEditableProfile";
import DialogBox from "./DialogBox";
import Cookies from "js-cookie";
import LaunchOutlinedIcon from "@mui/icons-material/LaunchOutlined";
import dayjs from "dayjs";
import VisibilityIcon from "@mui/icons-material/Visibility";
// New icons for updated UI
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ px: 1 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 550,
  bgcolor: "background.paper",
};

const options = [
  "Create a merge commit",
  "Squash and merge",
  "Rebase and merge",
];

const CandidateDetails = ({
  isOpen,
  candidatedrawerflag,
  onClose,
  selectedRowData,
  verifiedstatus,
  setrefreshagain,
  refreshagain,
  issearchnavbar,
  opennew,
  setOpennew,
  activitydisable,
  setactivitydisable,
  responsehide,
  Shortlisted,
  questionrequired,
  setApplicanOpen,
  isApplicanOpen,
  testingdata,
  Jobstatus,
}) => {
  const PermissionStatus = useSelector((state) => state.user.permissions);
  const AddCandidatePermission = PermissionStatus["100"];
  const [value, setValue] = React.useState(0);
  const [candidatedetails, setcandidatedetails] = useState([]);
  const getToken = useSelector((state) => state.user.token);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [status, setstatus] = useState([]);
  // const [open, setOpen] = React.useState(false);
  const [addtoJob, setAddtoJob] = useState(false);
  const [jobOrder, setJobOrder] = useState("");
  const [joborderIds, setJoborderIds] = useState();
  const [inputValueJobOrder, setInputValueJobOrder] = useState("");
  const [jobOrderOptions, setJobOrderOptions] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [activitesrefresh, setactivitesrefresh] = useState(false);
  const [newvalues, setnewvalue] = useState(0);
  const [statusupdate, setstatusupdate] = useState(selectedRowData?.status);
  const [questionData, setQuestionData] = useState([]);
  const [questionrequiredflag, setquestionrequiredflag] = useState();
  const [quesOpenPopup, setQuesOpenPopup] = useState(false);
  const [quesAnsArray, setQuesAnsArray] = useState([]);
  const [textFields, setTextFields] = useState({});
  const [radioValues, setRadioValues] = useState({});
  const [closedrawer, setclosedrawer] = useState(isOpen);
  const resumeSectionRef = useRef(null);
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const title = "Change Status";
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [comment, setComment] = useState("");

  const openDialog = () => {
    setIsDialogOpen(true);
  };
  const closeDialog = () => {
    setIsDialogOpen(false);
    setComment("");
  };

  const update_date = testingdata?.filter(
    (e) => e?.id === selectedRowData?.id,
  )[0]?.date_modified;

  const saveCommentAndStatus = () => {
    const obj = {
      id: selectedRowData.id,
      date_modified: update_date,
    };
    axios
      .post(
        `change-candidate-job-status`,
        {
          candidate_ids: [obj],
          job_id: selectedRowData.joborder_id,
          status: selectedStatus,
          comment: comment,
        },
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          handleSnackbarOpen("Candidate Status Changed Successfully");
          setrefreshagain(!refreshagain);
          setactivitesrefresh(!activitesrefresh);
          setnewvalue(1);
          setstatusupdate(selectedStatus);
        }
      })
      .catch((err) => {
        handleSnackbarOpen(err.response.data.error);
      });
    closeDialog();
  };

  const { id } = useParams();

  const handleSnackbarOpen = (message) => {
    setSnackbarMessage(message);
    setOpenSnackbar(true);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleClick = () => {};

  const handleClose = (event) => {
    setAddtoJob(false);
    setJobOrder("");
  };

  const handleToggle = () => {
    setOpennew((prevOpen) => !prevOpen);
  };

  const handleMenuItemClick = (event, index, item) => {
    setSelectedIndex(index);
    setSelectedStatus(item);
    openDialog();
    setOpennew(false);
  };

  useEffect(() => {
    axios
      .get(`candidate/job-status`, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      })
      .then((response) => {
        setstatus(response.data.message);
        setOpennew(false);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const fetchCandidateDetails = async () => {
    const candidate_id = selectedRowData?.id;
    console.log("candidate_id", candidate_id);

    if (!candidate_id) {
      console.log("candidate_id not found");
      return;
    }

    try {
      const response = await axios.post(
        `candidate/details/${candidate_id}?isEditableProfile=false`,
        { jobId: id },
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      );

      setcandidatedetails(response.data.message);
      setValue(newvalues);
    } catch (err) {
      console.error("Error fetching candidate details", err);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    fetchCandidateDetails();
  }, [isOpen, activitesrefresh, newvalues]);

  const validate = () => {
    let isValid = true;
    let updateQuesArr = [...quesAnsArray];
    updateQuesArr.forEach((item, index) => {
      if (item.question_types === 1) {
        if (item.answer_text === "") {
          item.error = "This field is required";
          isValid = false;
        } else if (item.answer_text.length >= 501) {
          item.error = "Maximum 500 characters allowed";
          isValid = false;
        } else {
          item.error = null;
        }
      } else if (item.question_types === 2) {
        if (item.answer_text === "") {
          item.error = "This field is required";
          isValid = false;
        } else if (item.answer_text.length >= 13) {
          item.error = "Maximum 12 digits allowed";
          isValid = false;
        } else {
          item.error = null;
        }
      } else if (item.question_types === 3) {
        if (item.answer_text === "") {
          item.error = "This field is required";
          isValid = false;
        } else {
          item.error = null;
        }
      }
    });
    setQuesAnsArray(updateQuesArr);
    return isValid;
  };

  const handleQuessummit = () => {
    if (!validate()) {
      return;
    }

    axios
      .post(
        `bulk-add/job?questionnaire=true`,
        {
          candidate_ids: [selectedRowData.id],
          job_id: joborderIds ? joborderIds : "" || id ? id : "",
          quesAnsArray: quesAnsArray,
          isShortlisted: 1,
        },
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          handleSnackbarOpen("Candidate Added Successfully");
          setAddtoJob(false);
          setJobOrder("");
          setTextFields({});
          setRadioValues({});
          setQuesOpenPopup(false);
          setTimeout(() => {
            setApplicanOpen(false);
          }, 500);
        } else {
          handleSnackbarOpen("The candidates have already applied");
          setAddtoJob(false);
          setJobOrder("");
          setQuesOpenPopup(false);
          setTimeout(() => {
            setApplicanOpen(false);
          }, 500);
        }
      })
      .catch((err) => {
        console.error("error");
        handleSnackbarOpen(err.response.data.error);
        setQuesOpenPopup(false);
        setAddtoJob(false);
        setJobOrder("");
      });
  };

  const handlequestionairequired = () => {
    if (questionrequired == 1) {
      setQuesOpenPopup(true);
    } else {
      handleAddCandidates();
    }
  };

  const handleAddCandidates = () => {
    axios
      .post(
        `bulk-add/job`,
        {
          candidate_ids: [selectedRowData.id],
          job_id: joborderIds ? joborderIds : "" || id ? id : "",
          quesAnsArray: [],
          isShortlisted: Shortlisted ? 1 : 0,
        },
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          handleSnackbarOpen("Candidate Added Successfully");
          setAddtoJob(false);
          setJobOrder("");
          if (Shortlisted || onClose) {
            setTimeout(() => {
              setApplicanOpen(false);
            }, 500);
          }
        } else {
          handleSnackbarOpen("The candidates have already applied");
          setAddtoJob(false);
          setJobOrder("");
        }
      })
      .catch((err) => {
        console.error("error");
        handleSnackbarOpen(err.response.data.error);
        setAddtoJob(false);
        setJobOrder("");
      });
  };

  useEffect(() => {
    setstatusupdate(selectedRowData?.status);
    axios
      .get(`all-jobs`, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      })
      .then((response) => {
        setJobOrderOptions(response?.data?.message);
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  }, []);

  useEffect(() => {
    setstatusupdate(selectedRowData?.status);
  }, [selectedRowData?.status]);

  const handleTabClick = () => {
    onClose();
    if (setactivitydisable) setactivitydisable(!activitydisable);
    setnewvalue(0);
  };

  const handleQuesPopupClose = () => {
    const a = quesAnsArray.map((question) => {
      return {
        question_types: question.question_types,
        question_id: question.question_id,
        ques_ans: question.ques_ans,
        answer_text: "",
        error: null,
      };
    });
    setQuesAnsArray(a);
    setQuesOpenPopup(false);
  };

  const handleViewResumeClick = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    setValue(0);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        resumeSectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      });
    });
  };

  const copyToClipboard = async () => {
    const x = process.env.REACT_APP_FRONTEND_URL;
    try {
      await navigator.clipboard.writeText(
        `${x}/Manage-Candidates/${selectedRowData?.id}`,
      );
      setSnackbarMessage("Copied");
      setAlertSeverity("success");
      setSnackbarOpen(true);
      setTimeout(() => {
        setSnackbarOpen(false);
      }, 1500);
    } catch (err) {
      setSnackbarMessage("Failed to copy the link.");
      setAlertSeverity("error");
      setSnackbarOpen(true);
    }
  };

  let tabIndex = -1;
  let customTabIndex = -1;

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}>
      <Box
        tabIndex={0}
        role="button"
        sx={{
          width: { xs: 400, sm: 500, md: 750, lg: 850 },
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "hidden",
        }}
      >
        {/* ══ TOP BAR: Profile Details | Prev / Next | × ══ */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2.5,
            py: 1.5,
            borderBottom: "1px solid rgba(0,0,0,0.08)",
            flexShrink: 0,
          }}
        >
          <Typography
            sx={{ fontSize: "16px", fontWeight: 700, color: "#151D48" }}
          >
            Profile Details
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {/* <Box sx={navBtnStyle}>
              <ChevronLeftIcon sx={{ fontSize: "14px", color: "#64748B" }} />
              <Typography sx={navBtnText}>Previous</Typography>
            </Box>
            <Box sx={navBtnStyle}>
              <Typography sx={navBtnText}>Next</Typography>
              <ChevronRightIcon sx={{ fontSize: "14px", color: "#64748B" }} />
            </Box> */}
            <Box onClick={handleTabClick} sx={closeBtnStyle}>
              <CloseIcon sx={{ fontSize: "16px", color: "#64748B" }} />
            </Box>
          </Box>
        </Box>

        {/* ══ CANDIDATE HEADER: Avatar + Info + Status button ══ */}
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            px: 2.5,
            pt: 2,
            pb: 1,
            gap: 2,
            flexShrink: 0,
          }}
        >
          {/* Left: avatar + all info */}
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: "12px",
              flex: 1,
              minWidth: 0,
            }}
          >
            {/* Avatar */}
            <Box sx={{ flexShrink: 0 }}>
              {candidatedetails.profile_path ? (
                <img
                  src={candidatedetails.profile_path}
                  style={{
                    borderRadius: "8px",
                    width: "64px",
                    height: "64px",
                    objectFit: "cover",
                  }}
                  alt="avatar"
                />
              ) : (
                <Avatar
                  style={{ width: 64, height: 64, borderRadius: "10px" }}
                />
              )}
            </Box>

            {/* Text info */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
              {/* Name */}
              <Typography
                variant="h4"
                sx={{
                  wordWrap: "break-word",
                  fontSize: "20px",
                  fontWeight: "600",
                  color: "rgba(0, 0, 0, 0.87)",
                  lineHeight: 1.3,
                }}
              >
                {candidatedetails.name ? candidatedetails.name : "NA"}
              </Typography>

              {/* Location */}
              {candidatedetails?.current_loc?.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "3px",
                    mb: "6px",
                  }}
                >
                  <LocationOnOutlinedIcon
                    sx={{ fontSize: "16px", color: "#000" }}
                  />
                  <Typography
                    variant="body1"
                    color={"text.secondary"}
                    className="fw-500"
                    sx={{
                      wordWrap: "break-word",
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "rgba(0, 0, 0, 0.60)",
                    }}
                  >
                    {candidatedetails.current_loc[0]?.label}
                  </Typography>
                </Box>
              )}

              {/* Current Employer */}
              <Typography
                variant="h6"
                sx={{
                  wordWrap: "break-word",
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "rgba(0, 0, 0, 0.60)",
                  mb: "4px",
                }}
                gutterBottom
              >
                {candidatedetails.current_employer
                  ? candidatedetails.current_employer
                  : "NA"}
              </Typography>

              {/* Meta info row: Created By, Last Login, Last Job Applied, Last Profile Updated */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  gap: "4px 16px",
                  mt: "2px",
                }}
              >
                {/* <Typography
                  variant="body1"
                  color={"text.secondary"}
                  className="fw-500"
                  gutterBottom
                  sx={{ fontSize: "12px" }}
                >
                  Created By:{" "}
                  <span style={{ color: "black" }}>
                    {selectedRowData?.entered_by}
                  </span>
                </Typography> */}

                {(candidatedetails?.entered_by === "Jobeze Admin" ||
                  candidatedetails?.last_login) && (
                  <Typography
                    variant="body1"
                    color={"text.secondary"}
                    className="fw-500"
                    gutterBottom
                    sx={{ marginBottom: 1, fontSize: "12px" }}
                  >
                    Last Login:{" "}
                    <span style={{ color: "black" }}>
                      {(() => {
                        if (!candidatedetails?.last_login)
                          return "More than 90 days ago";
                        const daysAgo = dayjs().diff(
                          dayjs(candidatedetails.last_login),
                          "days",
                        );
                        if (daysAgo <= 7) return "Last 7 days";
                        if (daysAgo <= 30) return "Last month";
                        if (daysAgo <= 90) return "Last 90 days";
                        return "More than 90 days ago";
                      })()}
                    </span>
                  </Typography>
                )}

                {(candidatedetails?.entered_by === "Jobeze Admin" ||
                  candidatedetails?.last_job_applied_date) && (
                  <Typography
                    variant="body1"
                    color={"text.secondary"}
                    className="fw-500"
                    gutterBottom
                    sx={{ marginBottom: 1, fontSize: "12px" }}
                  >
                    Last Job Applied:{" "}
                    <span style={{ color: "black" }}>
                      {(() => {
                        if (!candidatedetails?.last_job_applied_date)
                          return "More than 90 days ago";
                        const daysAgo = dayjs().diff(
                          dayjs(candidatedetails.last_job_applied_date),
                          "days",
                        );
                        if (daysAgo <= 7) return "Last 7 days";
                        if (daysAgo <= 30) return "Last month";
                        if (daysAgo <= 90) return "Last 90 days";
                        return "More than 90 days ago";
                      })()}
                    </span>
                  </Typography>
                )}

                {(candidatedetails?.entered_by === "Jobeze Admin" ||
                  candidatedetails?.last_profile_update) && (
                  <Typography
                    variant="body1"
                    color={"text.secondary"}
                    className="fw-500"
                    gutterBottom
                    sx={{ marginBottom: 1, fontSize: "12px" }}
                  >
                    Last Profile Updated On:{" "}
                    <span style={{ color: "black" }}>
                      {(() => {
                        if (!candidatedetails?.last_profile_update)
                          return "More than 90 days ago";
                        const daysAgo = dayjs().diff(
                          dayjs(candidatedetails.last_profile_update),
                          "days",
                        );
                        if (daysAgo <= 7) return "Last 7 days";
                        if (daysAgo <= 30) return "Last month";
                        if (daysAgo <= 90) return "Last 90 days";
                        return "More than 90 days ago";
                      })()}
                    </span>
                  </Typography>
                )}
              </Box>

              {/* View count */}
              <Box display="flex" alignItems="center" sx={{ mt: "2px" }}>
                <IconButton size="small" sx={{ p: "2px", mr: "4px" }}>
                  <VisibilityIcon sx={{ fontSize: "15px" }} />
                </IconButton>
                <Typography
                  variant="body2"
                  sx={{ fontSize: "12px", color: "#64748B" }}
                >
                  {candidatedetails?.candidate_view_count
                    ? `${candidatedetails?.candidate_view_count} views in last 90 days`
                    : "No data available"}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Right: status action button */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              flexShrink: 0,
              pt: "4px",
            }}
          >
            {candidatedrawerflag ? (
              <>
                {AddCandidatePermission?.add === 1 && (
                  <Button
                    variant="contained"
                    disabled={
                      Jobstatus === "Closed" ||
                      Jobstatus === "Cancelled" ||
                      Jobstatus === "Full"
                    }
                    onClick={handlequestionairequired}
                    sx={{
                      borderRadius: "6px",
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: "13px",
                    }}
                  >
                    {Shortlisted ? " Apply " : " Add to Job"}
                  </Button>
                )}
              </>
            ) : issearchnavbar ? (
              <Box>
                {AddCandidatePermission?.add === 1 && (
                  <Button
                    variant="contained"
                    disabled={
                      Jobstatus === "Closed" ||
                      Jobstatus === "Cancelled" ||
                      Jobstatus === "Full"
                    }
                    onClick={() => {
                      setAddtoJob(true);
                    }}
                    sx={{
                      borderRadius: "6px",
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: "13px",
                    }}
                  >
                    Add to Job
                  </Button>
                )}
                <Modal
                  open={addtoJob}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        pr: 1,
                      }}
                    >
                      <Typography
                        id="modal-modal-title"
                        variant="h5"
                        className="fw-500"
                        p={2}
                      >
                        Add to Job
                      </Typography>
                      <IconButton
                        type="button"
                        size="small"
                        onClick={handleClose}
                        aria-label="Close"
                        sx={{
                          mr: 1,
                          color: "#64748B",
                          "&:hover": {
                            backgroundColor: "rgba(15, 23, 42, 0.06)",
                          },
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Box>
                    <Divider />
                    <Typography id="modal-modal-description" sx={{ p: 2 }}>
                      <Typography variant="body2" className="fw-400">
                        Select Job
                      </Typography>
                      <Autocomplete
                        value={jobOrder}
                        onChange={(event, newValue) => {
                          setJobOrder(newValue);
                        }}
                        inputValue={inputValueJobOrder}
                        onInputChange={(event, newInputValue) => {
                          const joborderId = newInputValue
                            .split(",")
                            .pop()
                            .trim();
                          setJoborderIds(joborderId);
                          setInputValueJobOrder(newInputValue);
                        }}
                        id="controllable-states-demo"
                        options={jobOrderOptions.map(
                          (option) => `${option.title}, ${option.joborder_id}`,
                        )}
                        sx={{ mt: 2 }}
                        renderInput={(params) => (
                          <TextField {...params} label="Job" />
                        )}
                      />
                      <Box
                        sx={{ mt: 2 }}
                        display={"flex"}
                        alignItems={"center"}
                        gap={1.5}
                        flexWrap={"wrap"}
                      ></Box>
                    </Typography>
                    <Divider />
                    <Typography
                      id="modal-modal-footer"
                      variant="body2"
                      sx={{
                        p: 1.8,
                        display: "flex",
                        gap: { xs: 1, sm: 2, md: 2, lg: 2 },
                        justifyContent: "end",
                        alignItems: "center",
                      }}
                    >
                      <Button className="cancel-btn" variant="text" size="small" onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={handleAddCandidates}
                      >
                        Add
                      </Button>
                    </Typography>
                  </Box>
                </Modal>
              </Box>
            ) : (
              <Box>
                {verifiedstatus !== 0 ? (
                  <Box>
                    {AddCandidatePermission?.edit === 1 && (
                      <>
                        {/* STATUS split button — screenshot style */}
                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            borderRadius: "6px",
                            overflow: "hidden",
                            cursor: "pointer",
                          }}
                        >
                          <Box
                            ref={anchorRef}
                            sx={{
                              px: "16px",
                              height: "34px",
                              backgroundColor: "#3F95EA",
                              display: "flex",
                              alignItems: "center",
                              borderRadius: "6px 0 0 6px",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "13px",
                                fontWeight: 700,
                                color: "#fff",
                                letterSpacing: "0.8px",
                              }}
                            >
                              STATUS
                            </Typography>
                          </Box>
                          <Box
                            onClick={handleToggle}
                            sx={{
                              px: "8px",
                              height: "34px",
                              backgroundColor: "#2d7fd4",
                              borderLeft: "1px solid rgba(255,255,255,0.3)",
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              borderRadius: "0 6px 6px 0",
                              "&:hover": { backgroundColor: "#1a6bbf" },
                            }}
                          >
                            <KeyboardArrowDownIcon
                              sx={{ fontSize: "18px", color: "#fff" }}
                            />
                          </Box>
                        </Box>

                        <Popper
                          sx={{ zIndex: 1300 }}
                          open={opennew}
                          anchorEl={anchorRef.current}
                          role={undefined}
                          transition
                          disablePortal
                        >
                          {({ TransitionProps, placement }) => (
                            <Grow
                              {...TransitionProps}
                              style={{
                                transformOrigin:
                                  placement === "bottom"
                                    ? "center top"
                                    : "center bottom",
                              }}
                            >
                              <Paper
                                sx={{
                                  mt: "4px",
                                  borderRadius: "8px",
                                  boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                                  minWidth: "140px",
                                }}
                              >
                                <ClickAwayListener onClickAway={handleClose}>
                                  <MenuList
                                    id="split-button-menu"
                                    autoFocusItem
                                  >
                                    {status.map((option, index) => (
                                      <MenuItem
                                        key={option.status}
                                        value={option.status}
                                        disabled={
                                          statusupdate === option.status ||
                                          statusupdate === "Withdrawn"
                                            ? true
                                            : false
                                        }
                                        onClick={(event) =>
                                          handleMenuItemClick(
                                            event,
                                            index,
                                            option.status,
                                          )
                                        }
                                        sx={{ fontSize: "13px" }}
                                      >
                                        {option.status}
                                      </MenuItem>
                                    ))}
                                  </MenuList>
                                </ClickAwayListener>
                              </Paper>
                            </Grow>
                          )}
                        </Popper>

                        <DialogBox
                          title={title}
                          closeDialog={closeDialog}
                          isDialogOpen={isDialogOpen}
                          comment={comment}
                          setComment={setComment}
                          saveCommentAndStatus={saveCommentAndStatus}
                        />
                      </>
                    )}
                  </Box>
                ) : (
                  <Button size="small" variant="contained" color="error">
                    unverified
                  </Button>
                )}
              </Box>
            )}
          </Box>
        </Box>

        {/* ══ INFO CHIPS ROW ══ */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "6px",
            alignItems: "center",
            padding: "16px 20px",
            // borderBottom: "1px solid rgba(0,0,0,0.08)",
            flexShrink: 0,
          }}
        >
          {/* By (created by) */}
          <Box sx={chipStyle}>
            <PersonOutlineOutlinedIcon
              sx={{ fontSize: "16px", color: "#3F95EA" }}
            />
            <Typography sx={chipText}>
              By {selectedRowData?.entered_by || "NA"}
            </Typography>
          </Box>

          {/* Email */}
          <a
            href={"mailto:" + candidatedetails.email}
            rel="noreferrer"
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <Box sx={chipStyle}>
              <EmailOutlinedIcon sx={{ fontSize: "16px", color: "#3F95EA" }} />
              <Typography sx={chipText}>
                {candidatedetails.email || "Email"}
              </Typography>
            </Box>
          </a>

          {/* Cover Letter */}
          {candidatedetails?.cover_letter !== null &&
            candidatedetails?.cover_letter?.trim() !== "" && (
              <a href="#coverletterscrol" style={{ textDecoration: "none" }}>
                <Box sx={chipStyle}>
                  <InsertDriveFileOutlinedIcon
                    sx={{ fontSize: "16px", color: "#3F95EA" }}
                  />
                  <Typography sx={chipText}>Cover Letter</Typography>
                </Box>
              </a>
            )}

          {/* View Resume */}
          <Box
            sx={{
              ...chipStyle,
              cursor: "pointer",
            }}
            onClick={handleViewResumeClick}
            component="button"
            type="button"
          >
            <InsertDriveFileOutlinedIcon
              sx={{ fontSize: "16px", color: "#3F95EA" }}
            />
            <Typography sx={chipText}>View Resume</Typography>
          </Box>

          {/* LinkedIn */}
          {candidatedetails.linkedIn && (
            <a
              href={
                candidatedetails.linkedIn.startsWith("http")
                  ? candidatedetails.linkedIn
                  : `https://${candidatedetails.linkedIn}`
              }
              rel="noreferrer"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <Box sx={chipStyle}>
                <LinkOutlinedIcon sx={{ fontSize: "16px", color: "#3F95EA" }} />
                <Typography sx={chipText}>LinkedIn</Typography>
                <LaunchOutlinedIcon
                  sx={{ fontSize: "16px", color: "#3F95EA" }}
                />
              </Box>
            </a>
          )}

          {/* Share Profile */}
          <Box
            sx={{ ...chipStyle, cursor: "pointer" }}
            onClick={copyToClipboard}
          >
            <ShareIcon sx={{ fontSize: "16px", color: "#3F95EA" }} />
            <Typography sx={chipText}>Share Profile</Typography>
          </Box>

          {/* Open in new tab */}
          <Box
            sx={{ ...chipStyle, cursor: "pointer" }}
            onClick={() => {
              const x = process.env.REACT_APP_FRONTEND_URL;
              const url = `${x}/Manage-Candidates/${selectedRowData?.id}`;
              window.open(url, "_blank");
            }}
          >
            <LaunchOutlinedIcon sx={{ fontSize: "14px", color: "#3F95EA" }} />
            <Typography sx={chipText}>Open in new tab</Typography>
          </Box>

          {/* Snackbar for copy */}
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={4000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Alert
              onClose={handleSnackbarClose}
              severity={alertSeverity}
              variant="filled"
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </Box>

        {/* ══ TABS ══ */}
        <Box
          sx={{
            borderBottom: "1px solid rgba(0,0,0,0.08)",
            px: 1,
            flexShrink: 0,
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            className="fw-700"
            aria-label="basic tabs example"
            sx={{
              "& .MuiTabs-indicator": {
                height: "2px",
                borderRadius: "2px",
                backgroundColor: "#3F95EA",
              },
              "& .MuiTab-root": {
                fontSize: "12px",
                fontWeight: 600,
                letterSpacing: "0.6px",
                minHeight: "44px",
                padding: "6px 16px",
                color: "#94A3B8",
                textTransform: "uppercase",
              },
              "& .Mui-selected": { color: "#3F95EA !important" },
              minHeight: "44px",
            }}
          >
            <Tab label="Candidate Info" {...a11yProps(++tabIndex)} />

            {!Shortlisted &&
              !activitydisable &&
              window.location.pathname !== "/searchCandidate" && (
                <Tab label="Activities" {...a11yProps(++tabIndex)} />
              )}
            <Tab label="Internal Profile" {...a11yProps(++tabIndex)} />
            {!Shortlisted &&
              responsehide &&
              window.location.pathname !== "/searchCandidate" && (
                <Tab label="Response" {...a11yProps(++tabIndex)} />
              )}
          </Tabs>
        </Box>

        {/* ══ TAB CONTENT (scrollable) ══ */}
        <Box sx={{ overflowY: "auto", flexGrow: 1, padding: "0 20px 0 20px" }}>
          <CustomTabPanel value={value} index={++customTabIndex}>
            <CandidateInfo
              candidatedetails={candidatedetails}
              refreshCandidateDetails={fetchCandidateDetails}
              resumeSectionRef={resumeSectionRef}
              layout="column"
            />
          </CustomTabPanel>
          {!Shortlisted &&
            !activitydisable &&
            window.location.pathname !== "/searchCandidate" && (
              <CustomTabPanel value={value} index={++customTabIndex}>
                <CandidateActivities
                  handleSnackbarOpen={handleSnackbarOpen}
                  selectedStatus={selectedStatus}
                  setstatusupdate={setstatusupdate}
                  setnewvalue={setnewvalue}
                  setactivitesrefresh={setactivitesrefresh}
                  activitesrefresh={activitesrefresh}
                  refreshagain={refreshagain}
                  setrefreshagain={setrefreshagain}
                  selectedRowData={selectedRowData}
                  candidatedetails={candidatedetails}
                  activitydisable={activitydisable}
                />
              </CustomTabPanel>
            )}
          <CustomTabPanel value={value} index={++customTabIndex}>
            <CandidateEditableProfile
              candidateId={selectedRowData?.id}
              onClose={onClose}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={++customTabIndex}>
            <Questionnairedata id={id} candidateId={selectedRowData?.id} />
          </CustomTabPanel>
        </Box>
      </Box>

      {/* ══ SNACKBAR ══ */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={
            snackbarMessage == "Candidate Status Changed Successfully" ||
            snackbarMessage === "Candidate Added Successfully" ||
            snackbarMessage === "Comment Added Successfully" ||
            snackbarMessage === "Comment updated successfully" ||
            snackbarMessage === "Comment deleted successfully"
              ? "success"
              : "error"
          }
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Questionpop
        quesOpenPopup={quesOpenPopup}
        quesAnsArray={quesAnsArray}
        setQuesAnsArray={setQuesAnsArray}
        handleQuesPopupClose={handleQuesPopupClose}
        handleQuessummit={handleQuessummit}
        textFields={textFields}
        setTextFields={setTextFields}
        radioValues={radioValues}
        setRadioValues={setRadioValues}
      />
    </Drawer>
  );
};

// ── Shared micro styles ──────────────────────────────────────────────────────
const navBtnStyle = {
  display: "flex",
  alignItems: "center",
  gap: "2px",
  px: "10px",
  height: "28px",
  border: "1px solid #E2E8F0",
  borderRadius: "6px",
  cursor: "pointer",
  backgroundColor: "#fff",
  "&:hover": { backgroundColor: "#F8FAFC" },
};
const navBtnText = {
  fontSize: "12px",
  color: "#64748B",
  fontWeight: 500,
  userSelect: "none",
};
const closeBtnStyle = {
  width: "28px",
  height: "28px",
  // border: "1px solid #E2E8F0",
  // borderRadius: "6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  ml: "4px",
  // "&:hover": {
  //   backgroundColor: "#FFF5F5",
  //   borderColor: "#FECACA"
  // },
};
const chipStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: "5px",
  px: "10px",
  py: "5px",
  border: "1px solid #E2E8F0",
  borderRadius: "20px",
  backgroundColor: "#F9F9F9",
  "&:hover": { backgroundColor: "#EFF6FF", borderColor: "#BFDBFE" },
};
const chipText = { fontSize: "12px", fontWeight: 400, color: "#006CB7" };

export default CandidateDetails;
